import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getINVENTORYUPDATEDTableStructure";
export const UPDATE_TABLE_DATA = "updateINVENTORYUPDATEDTableData";
export const EXPORT_TABLE_DATA = "exportINVENTORYUPDATEDTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setINVENTORYUPDATEDTableStructure";
export const SET_TABLE_DATA = "setINVENTORYUPDATEDTableData";
export const SET_TABLE_FILTER = "setINVENTORYUPDATEDTableFilter";
export const SET_TABLE_PAGE = "setINVENTORYUPDATEDTablePage";
export const SET_TABLE_PERPAGE = "setINVENTORYUPDATEDTablePerPage";
export const SET_TABLE_SORTBY = "setINVENTORYUPDATEDTableSortBy";
export const SET_TABLE_SORTORDER = "setINVENTORYUPDATEDTableSortOrder";
export const SET_EXPORT_LINK = "setINVENTORYUPDATEDExportLink";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  /**
   * for table title, description
   * */
  getINVENTORYUPDATEDTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getINVENTORYUPDATEDTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getINVENTORYUPDATEDTableState(state) {
    // console.log("table state is ", state.table_state);
    return state.table_state;
  },

  getINVENTORYUPDATEDTableHeaders(state) {
    return state.table_structure.columns;
  },

  getINVENTORYUPDATEDTableFilters(state) {
    return state.table_structure.filters;
  },

  getINVENTORYUPDATEDTableData(state) {
    return state.table_data.data;
  },

  getINVENTORYUPDATEDExportUrl(state) {
    return state.export_link;
  },
  getINVENTORYUPDATEDUploadType(state) {
    return state.table_structure.type;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    // console.log(payload);
    return new Promise((resolve) => {
      ApiService.post("/order_management/inventories_updated")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      // ApiService.post("login", credentials)
      ApiService.post(
        "/order_management/inventories_updated/datatable",
        payload
      )
        .then(({ data }) => {
          // console.log("data of datatable ", data);
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/order_management/inventories_updated/export", payload)
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
